export default "__VITE_ASSET__Cm78ezSm__"